import { render, staticRenderFns } from "./HomeDashboardHub.vue?vue&type=template&id=af994648&scoped=true"
import script from "./HomeDashboardHub.vue?vue&type=script&lang=js"
export * from "./HomeDashboardHub.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboardHub.vue?vue&type=style&index=0&id=af994648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af994648",
  null
  
)

export default component.exports